import { Dictionary } from 'lodash';

export const concatParameterSyntax = 'concat({0})';
export const parameterSyntax = 'parameters(\'{0}\')';
export const variableSyntax = 'variables(\'{0}\')';
export const resourceIdSyntax = 'resourceId({0}, {1})';
export const integrationRuntimeParamPrefix = 'integrationRuntime_';
export const akvSpecValue = { secretName: '=' };
export const containerUriParam: string = 'containerUri';
export const containerSasToken: string = 'containerSasToken';

export interface IArmTemplate {
    $schema: string;
    parameters?: Dictionary<IArmTemplateParameter>;
    variables?: Dictionary<string>;
    contentVersion: string;
    // eslint-disable-next-line @typescript-eslint/array-type
    resources?: IArmTemplateResource[];
}

export interface IArmTemplateTypeProperty {
    type: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
}

export interface IArmTemplateProperties {
    type: string;
    typeProperties: Dictionary<IArmTemplateTypeProperty>;
    tags: {};
}

export interface IArmTemplateResource {
    name: string;
    type: string;
    apiVersion: string;
    properties: IArmTemplateProperties;
    dependsOn: string[];
    location?: string;
}

export interface IDependency {
    conceptType: string;
    resourceName: string;
}

export interface IArmTemplateParameter {
    // eslint-disable-next-line
    type: string;
    metadata?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    defaultValue?: any;
}

export interface IPublishingStatusError {
    message: string;
    code?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    details?: any[];
}

export enum TemplateBreakingOptions {
    NoBreaking,
    LinkedTemplateBased,
    PublishBased
}
